import data from "./data";
import WygenerowaneTable from "./table";
const Wygenerowane = () => {
    return (
      <>
        <WygenerowaneTable></WygenerowaneTable>
      </>
    );
  };
  export default Wygenerowane;